export default "__VITE_ASSET__CZaCDLyl__"